// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__20w8u","cell":"ColumnAccessor_cell__29YPO","firstCellAccent":"ColumnAccessor_firstCellAccent__1x5qn"};